import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { preloadArt } from './lib/art';
import { installAudioUnlock, renderMusicWav } from './lib/audio';
import '@fontsource-variable/inter';
import '@fontsource-variable/unbounded';
import '@fontsource/lilita-one';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// A arte do tema vai baixando em segundo plano enquanto a galera entra na sala.
setTimeout(preloadArt, 1200);
installAudioUnlock();

// Só para gravar a trilha em arquivo (scripts/trilha.mjs abre a página com ?gravar-trilha).
if (location.search.includes('gravar-trilha')) (window as unknown as { renderMusicWav: typeof renderMusicWav }).renderMusicWav = renderMusicWav;
